import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const CriticalValueAlert = ({ alerts, onAcknowledge, onViewDetails }) => {
  if (alerts?.length === 0) {
    return null;
  }

  return (
    <div className="space-y-3">
      {alerts?.map((alert) => (
        <div
          key={alert?.id}
          className="bg-destructive/10 border border-destructive rounded-lg p-4 md:p-6"
        >
          <div className="flex items-start gap-3 md:gap-4">
            <div className="flex-shrink-0">
              <div className="flex items-center justify-center w-10 h-10 md:w-12 md:h-12 bg-destructive/20 rounded-lg">
                <Icon name="AlertCircle" size={24} color="var(--color-destructive)" />
              </div>
            </div>
            <div className="flex-1 min-w-0">
              <h3 className="text-base md:text-lg font-semibold text-destructive mb-1">
                Critical Value Alert
              </h3>
              <p className="text-sm md:text-base text-foreground mb-2">
                <span className="font-semibold">{alert?.testName}:</span> {alert?.value} {alert?.unit}
              </p>
              <p className="text-xs md:text-sm text-muted-foreground mb-3">
                Reference Range: {alert?.referenceRange} | Detected: {alert?.detectedTime}
              </p>
              <p className="text-sm md:text-base text-foreground mb-4">{alert?.clinicalSignificance}</p>
              <div className="flex flex-col sm:flex-row gap-2 md:gap-3">
                <Button
                  variant="destructive"
                  size="sm"
                  onClick={() => onAcknowledge(alert?.id)}
                  iconName="Check"
                  iconPosition="left"
                >
                  Acknowledge
                </Button>
                <Button
                  variant="outline"
                  size="sm"
                  onClick={() => onViewDetails(alert)}
                  iconName="FileText"
                  iconPosition="left"
                >
                  View Details
                </Button>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default CriticalValueAlert;